import { render, staticRenderFns } from "./CriterionSelectorDialog.vue?vue&type=template&id=3bfe25ad"
import script from "./CriterionSelectorDialog.vue?vue&type=script&lang=ts"
export * from "./CriterionSelectorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports